import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import DataGridTable from "../../../../components/Table/data-grid-table"
import { useNavigate } from "react-router-dom"
import { MODULOS_CADASTRO_EVENTOS } from "../../CadastroEventos/cadastro-motor-eventos-const"
import {
    MOTOR_EVENTOS_CADASTRO_PAGE, 
    MOTOR_CADASTRO_MANUAL_PAGE
} from "src/utils/routes"

const StatusAnaliticoCadastro = ({loading}) => {
    const [rows, setRows] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        loadMockData()
    }, [])

    const loadMockData = () => {
        const data = [
            {
                id: 1,
                cetip: "NUVI11",
                versaoDocumento: 1,
                consolidado: "Em produção",

                caracteristicas:
                    "Em produção\nMaria Silva\nDtCriacao: 06/04/2026 h:m:s\nDtAtualizacao: 06/04/2026 h:m:s",

                parametros:
                    "Em andamento\nPedro Souza\nDtCriacao: 06/04/2026 h:m:s\nDtAtualizacao: 06/04/2026 h:m:s",

                eventosOrdinarios:
                    "Em produção\nMaria Silva\nDtCriacao: 06/04/2026 h:m:s\nDtAtualizacao: 06/04/2026 h:m:s",

                eventosExtraordinarios:
                    "Em produção\nMaria Silva\nDtCriacao: 06/04/2026 h:m:s\nDtAtualizacao: 06/04/2026 h:m:s",
            },
        ]

        setRows(data)
    }

    const handleNavigate = (row, modulo) => {
        if (modulo === MODULOS_CADASTRO_EVENTOS.CARACTERISTICAS) {
            navigate(MOTOR_CADASTRO_MANUAL_PAGE, {
                state: {
                    CETIP: row.cetip,
                    VersaoDocumento: row.versaoDocumento,
                    RendaFixaCaracteristicasID: row.id,
                    origem: "status-analitico",
                },
            })
            return
        }

        navigate(MOTOR_EVENTOS_CADASTRO_PAGE, {
            state: {
                CETIP: row.cetip,
                VersaoDocumento: row.versaoDocumento,
                RendaFixaCaracteristicasID: row.id,
                origem: "status-analitico",
                initialTab: modulo,
            },
        })
    }

    const renderStatusCell = (value) => {
        if (!value) return "-"

        const lines = value.split("\n")

        return (
            <div style={{lineHeight: "1.3"}}>
                <strong>{lines[0]}</strong>
                <div>{lines[1]}</div>
                <div style={{fontSize: 11, color: "#666"}}>{lines[2]}</div>
                <div style={{fontSize: 11, color: "#666"}}>{lines[3]}</div>
            </div>
        )
    }

    const renderClickableCell = (modulo) => {
        const Cell = (params) => (
            <div
                style={{
                    cursor: "pointer",
                    width: "100%",
                }}
                onClick={() => handleNavigate(params.row, modulo)}
            >
                {renderStatusCell(params.value)}
            </div>
        )

        Cell.displayName = `ClickableCell_${modulo}`

        return Cell
    }

    const columns = () => [
        {field: "cetip", headerName: "CETIP", flex: 1},
        {field: "versaoDocumento", headerName: "Ver. Doc.", flex: 1},
        {field: "consolidado", headerName: "Consolidado", flex: 1},

        {
            field: "caracteristicas",
            headerName: "Características",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.CARACTERISTICAS),
        },
        {
            field: "parametros",
            headerName: "Parâmetros",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.PARAMETROS),
        },
        {
            field: "eventosOrdinarios",
            headerName: "Ev. Ordinários",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.EVENTOS_ORDINARIOS),
        },
        {
            field: "eventosExtraordinarios",
            headerName: "Ev. Extraord.",
            flex: 2,
            renderCell: renderClickableCell(MODULOS_CADASTRO_EVENTOS.EVENTOS_EXTRAORDINARIOS),
        },
    ]

    return (
        <DataGridTable
            rows={rows}
            columns={columns()}
            loading={loading}
            disableRowSelectionOnClick
            pointerCursor
            autoRowHeight
        />
    )
}

StatusAnaliticoCadastro.propTypes = {
    loading: PropTypes.bool,
}

export default StatusAnaliticoCadastro